module.exports = __webpack_public_path__ + "static/img/8.ae67982.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/eng/8.png
// module id = XHk+
// module chunks = 0